import './Ademas.css';

function Ademas() {

    return (
        <div className="Ademas">

            <p className="Ademas-title">Además...</p>

            <a className="Ademas-pasate" href="https://infinitcom.com.ar/portabilidadnumerica/" target="_blank" rel="noreferrer">
                <p className="Ademas-pasate-p">¡PASATE MANTENIENDO TU NÚMERO!</p>
                <div className="App-pasate-right">
                    <p className="Ademas-pasate-off">80% OFF</p>
                    <p className="Ademas-pasate-meses">x 12 MESES</p>
                </div>
            </a>

        </div>
    );
}

export default Ademas;